import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import BG1 from "./files/p1_1.png";
import BG11 from "./files/p1.png";
import BG2 from "./files/p2_2.png";
import BG22 from "./files/p2.png";
import BG3 from "./files/p3_3.png";
import BG33 from "./files/p3.png";
import BG4 from "./files/p4_4.png";
import BG44 from "./files/p4.png";
import BG5 from "./files/p5_5.png";
import BG55 from "./files/p5.png";
import BG6 from "./files/p6_6.png";
import BG66 from "./files/p6.png";

import styles from "./heatmeters.module.css";

class HeatmetersSlide extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div
          style={{
            flex: "1",
            width: "100%",
            paddingTop: "3%",
            fontWeight: "600",
            textAlign: "center"
          }}
        >
          <span style={{ fontSize: "1.35vw" }}>
            ИС Теплоинформ поддерживает более 50 различных приборов
          </span>
        </div>
        <div style={{ flex: "6.5", width: "100%" }}>
          <div
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center"
            }}
          >
            <div style={{ flex: "1" }} className={styles.bgTextContainer1}>
              <Link to="/hmeters#routMetersHeatmeters">
                <div className={styles.iconTextContainer1}>
                  <div
                    className={styles.iconContainer1}
                    style={{
                      backgroundImage: <img src={BG1} alt=""/>,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg1}>
                      <img src={BG1}  alt=""/>
                    </div>
                    <div className={styles.BGImg11}>
                      <img src={BG11}  alt=""/>
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "31%", fontWeight: "600" }}>
                      Тепловычислители
                  </span>
                  </div>
                </div>
              </Link>
            </div>

            <div style={{ flex: "1" }} className={styles.bgTextContainer3}>
              <Link to="/hmeters#controllersAndHubs">
                <div className={styles.iconTextContainer3}>
                  <div
                    className={styles.iconContainer3}
                    style={{
                      backgroundImage: <img src={BG3}  alt=""/>,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg3}>
                      <img src={BG3}  alt=""/>
                    </div>
                    <div className={styles.BGImg33}>
                      <img src={BG33}  alt=""/>
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "34%", fontWeight: "600" }}>
                      Контроллеры и
                  </span>
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <span style={{ paddingLeft: "39.2%", fontWeight: "600" }}>
                      регуляторы
                  </span>
                  </div>
                </div>
              </Link>

            </div>
            <div style={{ flex: "1" }} className={styles.bgTextContainer2}>
              <Link to="/hmeters#routMetersliquidFlowSensorsMeters">
                <div className={styles.iconTextContainer2}>
                  <div
                    className={styles.iconContainer2}
                    style={{
                      backgroundImage: <img src={BG2}  alt=""/>,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg2}>
                      <img src={BG2} />
                    </div>
                    <div className={styles.BGImg22}>
                      <img src={BG22}  alt=""/>
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "34%", fontWeight: "600" }}>
                      Счетчики воды
                  </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div style={{ paddingTop: "3vh", paddingBottom: "3vh" }} />
          <div
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center"
            }}
          >
            <div style={{ flex: "1" }} className={styles.bgTextContainer4}>
              <Link to="/hmeters#routGasMeters">
                <div className={styles.iconTextContainer4}>
                  <div
                    className={styles.iconContainer4}
                    style={{
                      backgroundImage: <img src={BG4}  alt=""/>,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg4}>
                      <img src={BG4} />
                    </div>
                    <div className={styles.BGImg44}>
                      <img src={BG44}  alt=""/>
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "29%", fontWeight: "600" }}>
                      Корректоры объема
                  </span>
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <span style={{ paddingLeft: "44.5%", fontWeight: "600" }}>
                      газа
                  </span>
                  </div>
                </div>
              </Link>
            </div>


            <div style={{ flex: "1" }} className={styles.bgTextContainer5}>
              <Link to="/hmeters#routElectroMeters">
                <div className={styles.iconTextContainer5}>
                  <div
                    className={styles.iconContainer5}
                    style={{
                      backgroundImage: <img src={BG5}  alt=""/>,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg5}>
                      <img src={BG5}  alt=""/>
                    </div>
                    <div className={styles.BGImg55}>
                      <img src={BG55} />
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "30.7%", fontWeight: "600" }}>
                      Электросчетчики
                  </span>
                  </div>
                </div>
              </Link>
            </div>

            <div style={{ flex: "1" }} className={styles.bgTextContainer6}>
              <Link to="/hmeters#routOutWaterMeters">
                <div className={styles.iconTextContainer6}>
                  <div
                    className={styles.iconContainer6}
                    style={{
                      backgroundImage: <img src={BG6}  alt=""/>,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg6}>
                      <img src={BG6}  alt=""/>
                    </div>
                    <div className={styles.BGImg66}>
                      <img src={BG66}  alt=""/>
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "30%", fontWeight: "600" }}>
                      Учёт сточных вод
                  </span>
                  </div>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </div >
    );
  }
}
export default HeatmetersSlide;
